import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef } from "@angular/core";
import { delay, SharedService } from '../../shared'
import {
    IQuestionnaireSection, IQuestionnaireSubSection, ICAMTherapieObj, ICAMTherapieResObj, ICAMTherapieEndResObj,
    EnumSectionStatus, EnumCAMTherapieName, EnumQuestionType, EnumFreeTextType, GenereateCAMRes, GenereateCAMEndRes,
    TherapieItemEmptyAnswer, getCategoryLabel, freeTextInputs, LANGUAGE_ENUM
} from '../questionnaire.model';
import { CamProductList, CamUnitList } from '../productList'
import { CamProductList_EN, CamUnitList_EN } from '../productList-en'


@Component({
    selector: 'cam-therapie',
    templateUrl: "./cam-therapie.component.html",
    styleUrls: ["./cam-therapie.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class CamTherapieComponent implements OnInit {
    @Input() InEditRecordPopup: boolean = false;
    @Input() LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    @Input() section: IQuestionnaireSection = null;
    @Input() subSection: IQuestionnaireSubSection = null;
    @Input() therapieObj: ICAMTherapieObj;
    @Input() status: EnumSectionStatus = EnumSectionStatus.ACTIVE;
    @Input() minMonth: string = "";
    @Input() maxMonth: string = "";

    EnumCAMTherapieName = EnumCAMTherapieName;
    EnumQuestionType = EnumQuestionType;
    EnumFreeTextType = EnumFreeTextType;

    EnumSectionStatus = EnumSectionStatus;


    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
    }

    fnAddExtraOption() {
        if (this.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        let responseData: any[] = this.therapieObj.responseData;
        switch (this.therapieObj.therapieName) {
            case EnumCAMTherapieName.CAMTherapie:
                responseData.push(GenereateCAMRes());
                this.therapieObj.responseData = responseData;
                break;
            case EnumCAMTherapieName.CAMTherapieEnd:
                responseData.push(GenereateCAMEndRes());
                this.therapieObj.responseData = responseData;
                break;
        }
    }

    getCamProductOptions(label) {
        if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
            return CamProductList_EN.find(a => a.label == label)?.options || [];
        } else {
            return CamProductList.find(a => a.label == label)?.options || [];
        }
    }

    therapieOptions(response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        if (itemKey === 'product' || itemKey === 'applicationUnit') {
            let label = response['category']?.value;
            label = getCategoryLabel(label, this.LANGUAGE);
            if (label) {
                switch (itemKey) {
                    case 'product':
                        let data = this.getCamProductOptions(label);
                        let options = data.map(a => a.label);
                        return options;
                    case 'applicationUnit':
                        {
                            if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
                                return CamUnitList_EN.find(a => a.label == label)?.options || [];
                            } else {
                                return CamUnitList.find(a => a.label == label)?.options || [];
                            }
                        }
                    default:
                        return [];
                }
            } else {
                return [];
            }
        } else {
            return this.therapieObj[itemKey].options;
        }
    }

    getLabelName(itemObj: ICAMTherapieObj, response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        if (itemKey == 'product') {
            let category = response['category'].value;
            if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
                switch (category) {
                    case 'Cannabis extract':
                        return "Exact name of the cannabis extract";
                    case 'Cannabis flowers':
                        return "Exact name of cannabis flowers";
                    case 'Capsules':
                        return "Exact name of the capsules";
                    case 'Other':
                        return "More detailed information";
                    default:
                        return itemObj[itemKey].label;
                }
            } else {
                switch (category) {
                    case 'Cannabisextrakt':
                        return "Genaue Bezeichnung des Cannabisextrakts";
                    case 'Cannabisblüten':
                        return "Genaue Bezeichnung der Cannabisblüten";
                    case 'Cannabiskapseln':
                    case 'Kapseln':
                        return "Genaue Bezeichnung der Kapseln";
                    case 'Andere':
                        return "Genauere Angaben";
                    default:
                        return itemObj[itemKey].label;
                }
            }
        } else {
            return itemObj[itemKey].label;
        }
    }

    isItemVisible(itemObj: ICAMTherapieObj, response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        if (itemKey == 'product') {
            let category = response['category'].value;
            switch (category) {
                case 'Cannabisextrakt':
                case 'Cannabisblüten':
                case 'Cannabiskapseln':
                case 'Kapseln':
                case 'Andere':
                case 'Cannabis extract':
                case 'Cannabis flowers':
                case 'Capsules':
                case 'Other':
                    return true;
                default:
                    return false;
            }
        } else {
            return true;
        }
    }

    isItemRequired(itemObj: ICAMTherapieObj, response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        if (itemKey == 'product') {
            let category = response['category'].value;
            switch (category) {
                case 'Cannabisextrakt':
                case 'Cannabisblüten':
                case 'Cannabiskapseln':
                case 'Kapseln':
                case 'Andere':
                case 'Cannabis extract':
                case 'Cannabis flowers':
                case 'Capsules':
                case 'Other':
                    return true;
                default:
                    return false;
            }
        } else {
            return itemObj[itemKey].required;
        }
    }

    getItemInputType(itemObj: ICAMTherapieObj, response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        if (itemKey === 'product') {
            let category = response['category'].value;
            switch (category) {
                case 'Cannabisextrakt':
                case 'Cannabisblüten':
                case 'Cannabiskapseln':
                case 'Kapseln':
                case 'Cannabis extract':
                case 'Cannabis flowers':
                case 'Capsules':
                    return EnumQuestionType.DROPDOWN;
                case 'Andere':
                case 'Other':
                    return EnumQuestionType.INPUT;
                default:
                    return EnumQuestionType.INPUT;
            }
        }
        else {
            return itemObj[itemKey].inputType;
        }
    }

    changeFunction(itemObj: ICAMTherapieObj, response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        response.hasError[itemKey] = false;
        if (itemKey === 'category') {
            response['product'] = TherapieItemEmptyAnswer();
            response['applicationUnit'] = TherapieItemEmptyAnswer();
        }
        if (!this.isTherapieFreeTextShow(itemObj, response, itemKey)) {
            response[itemKey].freeText = null;
        }
    }

    isTherapieFreeTextShow(itemObj: ICAMTherapieObj, response: ICAMTherapieResObj | ICAMTherapieEndResObj, itemKey: string) {
        let value = response[itemKey]?.value;
        if (value) {
            if (itemObj[itemKey].multiple) {
                var matched = freeTextInputs.filter(e => value.indexOf(e) !== -1);
                return matched.length > 0;
            } else {
                return freeTextInputs.indexOf(value) > -1;
            }
        }
        return false;
    }
}
